<template>
  <div class="w-64 bg-dark-800 h-screen border-r border-dark-600 flex flex-col">
    <!-- Logo/Title -->
    <router-link
      to="/"
      class="logo-section border-dark-600 flex items-center justify-center hover:opacity-85 transition-opacity duration-200 group"
    >
      <span class="text-2xl font-bold text-white group-hover:scale-105 transition-transform duration-200">FundRiskLab</span>
    </router-link>
    
    <!-- Navigation Tabs -->
    <nav class="flex-1 px-4 py-6 space-y-2">

      <button
        @click="handleAssetManagementClick"
        :class="[
          'block w-full text-left px-5 py-4 rounded-lg font-medium transition-colors duration-200 border-l-4',
          route.path === '/asset-management'
            ? 'border-primary bg-primary bg-opacity-15 text-white'
            : 'border-transparent text-gray-400 hover:text-white hover:bg-dark-700'
        ]"
      >
        <i class="bi bi-graph-up-arrow mr-4"></i>자산운용사 분석
      </button>

      <button
        @click="handleVerificationClick"
        :class="[
          'block w-full text-left px-5 py-4 rounded-lg font-medium transition-colors duration-200 border-l-4',
          route.path === '/verification'
            ? 'border-primary bg-primary bg-opacity-15 text-white'
            : 'border-transparent text-gray-400 hover:text-white hover:bg-dark-700'
        ]"
      >
        <i class="bi bi-clipboard-check mr-4"></i>투자상품설명서 검증
      </button>

      <button
        @click="handleRiskAnalysisClick"
        :class="[
          'block w-full text-left px-5 py-4 rounded-lg font-medium transition-colors duration-200 border-l-4',
          route.path === '/risk-analysis'
            ? 'border-primary bg-primary bg-opacity-15 text-white'
            : 'border-transparent text-gray-400 hover:text-white hover:bg-dark-700'
        ]"
      >
        <i class="bi bi-shield-exclamation mr-4"></i>리스크 분석
      </button>
    </nav>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { useAssetManagementStore } from '@/stores/assetManagement';
import { useVerificationStore } from '@/stores/verification';
import { useRiskAnalysisStore } from '@/stores/riskAnalysis';

const route = useRoute();
const router = useRouter();
const assetManagementStore = useAssetManagementStore();
const verificationStore = useVerificationStore();
const riskAnalysisStore = useRiskAnalysisStore();

const handleAssetManagementClick = () => {
  // 모든 store 초기화
  assetManagementStore.reset();
  verificationStore.reset();
  riskAnalysisStore.reset();
  router.push('/asset-management');
};

const handleVerificationClick = () => {
  verificationStore.reset();
  router.push('/verification');
};

const handleRiskAnalysisClick = () => {
  riskAnalysisStore.reset();
  router.push('/risk-analysis');
};
</script>

<style scoped>
/* .logo-section {
  padding-right: 1.5rem;
  padding-top: 3.3rem;
  padding-bottom: 1.0rem;
} */

.logo-section {
  padding-right: 1.5rem;
  padding-top: 2.5rem;
  padding-bottom: 0.5rem;
}
</style>
